<template>
  <div class="information-column-background-image">
    <div class="information-column-background-layer">

      <div class="row">
        <div class="col s12">
          <div class="left-align">
            <img v-if="content[contentType].logoUrl"
              class="information-column-logo"
              width="187"
              :src="content[contentType].logoUrl">
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col s12">
          <div class="row information-column-info-block left-align">
            <h5>
              {{ content[contentType].header }}
            </h5>
            <p>
              {{ content[contentType].message }}
            </p>
            <u>
              <a class="url-text" href="https://strukton.com/en/rail/remote-condition-monitoring" target="_blank">{{ content[contentType].footerUrl }}</a>
            </u>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  props: {
    informationType: {
      type: Number,
      default: null
    }
  },
  data () {
    return {
      contentType: 0,
      content: [{
        logoUrl: require('../../assets/strukton-logo-diapositief.png'),
        header: 'Improve your rail infrastructure management',
        message: 'POSS® is Strukton’s Preventive Maintenance and Fault Diagnosis System. Predictive maintenance contributes to optimally reliable, available, maintainable and safe railways.',
        footerUrl: 'www.possinfo.com'
      }, {
        logoUrl: undefined,
        header: 'Refreshing POSS data',
        message: 'POSS® is now retrieving the latest data.',
        footerUrl: ''
      }]
    }
  },
  methods: {
    setContent (val) {
      this.contentType = val
    }
  },
  watch: {
    informationType: function (newVal, oldVal) {
      this.setContent(newVal)
    }
  }
}
</script>

<style scoped>
  .url-text {
    color: white;
  }

  .information-column-logo {
    width: 213px;
    padding-left: 26px;
    padding-top: 24px;
  }

  .information-column-info-block {
    padding-top: 72px;
    padding-left: 63px;
    padding-right: 44px;
    color: rgba(255, 255, 255, 0.8);
  }

  .information-column-background-image {
    background-image: url('../../assets/login-background.jpg');
    background-size: cover;
    position: relative;
    width: 100%;
    height: 100%;
  }

  .information-column-background-layer {
      background-color: rgba(86, 204, 242, 0.9);
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/pages/login/_InformationColumn.vue